// Vuex module — Pemantauan Penugasan SPG Eksternal (P26_0031 AC-08.4).
//
// Halaman /offline-stores/spg-external. Endpointnya di routes/routes/unionweb.php
// grup `/spg-external`, dijaga auth:api + access (modul `spgexternal_*`).
//
// Tabelnya (`pos_external_assignments`) MILIK nfposbe: cabang yang menulis saat SPG
// check-in di perangkat POS. Dari sini satu-satunya perubahan yang boleh terjadi adalah
// memberhentikan penugasan — tidak ada aksi tambah maupun ubah, dan jangan menambahkannya
// di sini: check-in dilakukan orangnya sendiri di toko (AC-07.3).
import $axios from "../../api";

const PREFIX = "unionweb/spg-external";

const state = () => ({
  isLoading: false,
  // Bentuk paginator Laravel: { data, total, per_page, from, to, current_page }.
  list: { data: [], total: 0, per_page: 20, from: 0, to: 0 },
  page: 1,
});

const mutations = {
  SET_LOADING(s, v) {
    s.isLoading = v;
  },
  SET_LIST(s, v) {
    s.list = v || { data: [], total: 0, per_page: 20, from: 0, to: 0 };
  },
  SET_PAGE(s, v) {
    s.page = v;
  },
  // Baris yang baru diberhentikan TETAP TINGGAL, cuma berubah jadi tidak aktif — daftar
  // ini memuat penugasan yang sudah diberhentikan juga, supaya Riwayat Penugasan-nya
  // masih bisa dibuka. Karena itu total dan `to` tidak ikut berkurang: jumlah barisnya
  // memang tidak berubah.
  //
  // Barisnya sengaja tidak dipindah ke bawah di sini walau server mengurutkan yang aktif
  // di atas. Yang baru saja ditekan orang sebaiknya tetap di tempatnya supaya terlihat
  // apa yang berubah; urutannya menyesuaikan sendiri pada pemuatan berikutnya.
  DEACTIVATE_ROW(s, id) {
    s.list = {
      ...s.list,
      data: (s.list.data || []).map((row) =>
        row.id === id ? { ...row, is_active: false } : row
      ),
    };
  },
};

const actions = {
  async getList({ commit, state, rootState, dispatch }, query = "") {
    commit("SET_LOADING", true);

    try {
      const res = await $axios.get(
        `${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${query}`
      );
      commit("SET_LIST", res.data?.data?.assignments);
      return res.data;
    } catch (error) {
      dispatch(
        "Main/globalSweetAlert",
        error.response || { message: "Unknown error" },
        { root: true }
      );
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // GET riwayat satu orang, untuk modal Riwayat Penugasan. Dikunci `salesperson_code`,
  // bukan id barisnya: riwayat harus selamat walau baris keadaannya lenyap saat
  // rekonsiliasi cabang.
  //
  // Tidak menyimpan ke state — isinya milik satu modal yang terbuka sesaat, dan menaruhnya
  // di store berarti riwayat orang sebelumnya sempat terlihat saat modal berikutnya dibuka.
  async getHistory(_ctx, salespersonCode) {
    const res = await $axios.get(`${PREFIX}/history?salesperson_code=${salespersonCode}`);
    return res.data?.data?.history || [];
  },

  // POST berhentikan. Backend menolak baris yang sudah diberhentikan orang lain dengan
  // 422 berisi pesan siap baca — dibiarkan naik ke pemanggil supaya layar bisa
  // menampilkannya apa adanya, bukan diganti kalimat generik di sini.
  async stopAssignment({ commit }, id) {
    const res = await $axios.post(`${PREFIX}/remove`, { id });
    commit("DEACTIVATE_ROW", id);
    return res.data?.data;
  },
};

export default { namespaced: true, state, mutations, actions };
